import { BrowserRouter } from "react-router-dom";
import RouteContainer from "./components/common/RouteContainer";
import "./components/common/common.scss";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "./queryClient";

function App() {
  return (
    <BrowserRouter>
    <QueryClientProvider client={queryClient}>
        <RouteContainer/>
        </QueryClientProvider>
    </BrowserRouter>
  );
}

export default App;
